import React from 'react';
import {useDropzone} from 'react-dropzone'
import SarasTrans from '../../notifications/SarasTrans';

const SarasUpload = ({onFileSelect, enableDragNDrop})=>{
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    
    //with drag and drop
    const onDrop = (acceptedFiles) => {
        // console.log("drag drop 1", acceptedFiles);
        setSelectedFiles(acceptedFiles);

        onFileSelect(acceptedFiles);
    }

    // Disable click and keydown behavior
    //this component only supports uploading one file at a time
    const {getRootProps, getInputProps, open, isDragActive, isDragAccept, isDragReject} = 
        useDropzone({
            onDrop, 
            noClick: true, 
            noKeyboard: true,
            multiple: false,
            maxFiles: 1})

    //without drag and drop
    const onNormalSelect = (e) => {
        let files = e.currentTarget.files;
        // console.log("drag regular", files);
        setSelectedFiles(files);

        onFileSelect(files);
    }

    if(enableDragNDrop){
        //with drag and drop enabled
        return (
            <>
            <div {...getRootProps({className: `uiMediaDropZone ${isDragActive ? 'uiMediaActiveDropZone' : ''} ${isDragAccept ? 'uiMediaAcceptedDropZone' : ''} ${isDragReject ? 'uiMediaRejectedDropZone' : ''}`})}>
              <input {...getInputProps()} />
              {
                isDragActive ?
                  <p><SarasTrans value="Drop the files here" /></p> :
                  <>
                  <p><SarasTrans value="Drag 'n' Drop a file here, or select file" /></p>
                    <button className="uiActionButton" type="button" onClick={open}>
                    <SarasTrans value="Open File Selector" />
                    </button>
                </>
          }
            </div>
            <aside>
                <span className="uiLbl"><SarasTrans value="Selected file" /></span>
                <span>{selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : ''}</span>
            </aside>
            </>
          )        
    }

    //without drag and drop
    return(
        <input type='file' cassName="uiFormInput" onChange={onNormalSelect} />
    )
}

export default SarasUpload